// @flow
import { connect } from 'react-redux';

import ProtectedRoute from './ProtectedRoute';
import type { StateProps } from './ProtectedRoute';

import type { State } from 'store/State';
import { selectors as userSelectors } from 'store/reducers/user/';

/** Will only render the route if the user is authenticated */
const mapStateToProps = (state: State): StateProps => ({
  isEnabled: userSelectors.isLoggedIn(state)
});

export default connect(mapStateToProps)(ProtectedRoute);



// WEBPACK FOOTER //
// ./src/components/common/router/AuthenticatedRoute.js